import styled from 'styled-components';
import { useCreatorsHub } from '@/hooks';
import { HubIdentity } from '../HubIdentity';

const List = styled.div` display: flex; flex-direction: column; gap: 12px; `;
const Card = styled.article`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px;
`;
const Top = styled.div` display: flex; align-items: center; justify-content: space-between; gap: 8px; `;
const Topic = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.accentCyan};
  border: 1px solid ${({ theme }) => theme.color.glassBorder}; border-radius: ${({ theme }) => theme.radius.sm}; padding: 1px 8px;
`;
const Body = styled.p` margin: 10px 0 8px; color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.sm}; `;
const Meta = styled.div` display: flex; column-gap: 0.9em; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted}; `;
const Empty = styled.p` color: ${({ theme }) => theme.color.textMuted}; padding: 24px 0; `;

export function DiscussionsTab() {
  const { discussions } = useCreatorsHub();
  if (discussions.length === 0) return <Empty>No discussions yet.</Empty>;
  return (
    <List>
      {discussions.map((d) => (
        <Card key={d.id}>
          <Top>
            <HubIdentity name={d.name} handle={d.handle} av={d.av} time={d.time} />
            {d.topic && <Topic>{d.topic}</Topic>}
          </Top>
          <Body>{d.body}</Body>
          <Meta><span>{d.replies} replies</span><span>{d.cheers} cheers</span></Meta>
        </Card>
      ))}
    </List>
  );
}
